__turbopack_context__.v({
  "EmployeeSelect": "employee-select-module__2IjJKq__EmployeeSelect",
});
